import { lazy, Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const RegisterMetaAds = lazy(() => import('../pages/register-meta-ads'))

export const registerMetaAdsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/register-meta-ads',
  component: RegisterMetaAds,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
